<template>
  <pdf :src="base64ToBlobUrl(pdfSrc)"/>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfViewer',
  components: {pdf},
  props: {
    pdfSrc: String,
  },

  mounted() {
    console.log(this.pdfSrc,'This')
  },
  methods: {
    base64ToBlobUrl(base64) {
      if (!base64 || typeof base64 !== 'string') {
        return null
      }

      const base64Data = base64.includes(',')
        ? base64.split(',')[1]
        : base64

      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      return URL.createObjectURL(blob)
    }
  },
}
</script>
